<template>
    <v-layout row class="locations-group-row" v-dragscroll.x>
        <v-btn
            class="locations-group__btn mx-1"
            active-class="locations-group__btn-active"
            v-for="(location, index) in list"
            :key="index"
            :input-value="activeItem == index"
            depressed
            rounded
            @click="setActiveGroup(index)"
        >
            <v-img
                v-if="showInfoIcon && location == 'Неисправные'"
                width="22px"
                height="22px"
                :src="require('@/assets/icons/info_icon.svg')"
            ></v-img>
            {{ location }}
        </v-btn>
    </v-layout>
</template>

<script>
import { dragscroll } from 'vue-dragscroll';

export default {
    name: "Slider",
    directives: {
        dragscroll: dragscroll,
    },
    props: {
        value: {
            type: Number,
            default: 0,
        },
        list: {
            type: Array,
        },
        showInfoIcon: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            activeItem: 0,
        };
    },
    created() {
        this.activeItem = this.value;
    },
    watch: {
        value(val) {
            if (val != this.activeItem) {
                this.activeItem = val;
            }
        },
        activeItem(val) {
            this.$emit("input", val);
        },
    },
    methods: {
        setActiveGroup(index) {
            this.activeItem = index;
        },
    },
}
</script>
